import { Loader2 } from 'lucide-react';

export function FullPageSpinner() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="grid min-h-screen place-items-center bg-background text-foreground"
    >
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="size-8 animate-spin text-primary" aria-hidden />
        <span className="text-sm text-muted-foreground">Cargando…</span>
      </div>
    </div>
  );
}
